// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"wKd6s","disabled_link":"Q5iQu","disabledLink":"Q5iQu"};